module.exports = __webpack_public_path__ + "img/6.3c0b6375.jpg";